import { useEffect, useState } from "react";
import { Form } from "../../common/Form";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { CommonDialog } from "../../common/CommonDialog";
import {jwordAlignmentOptions, jwordRowHeightOptions, jwordUnitOptions, jwordValignOptions} from "./jword-config";
import { TabPanel, TabView } from "primereact/tabview";
import { Panel } from "primereact/panel";
import { useTranslation } from "react-i18next";

export function TableFormatDialog({tableProps,visible,onOK,onCancel})
{    
    const {t} = useTranslation();
    const [tableInfo,setTableInfo]=useState({inheritMargins:true,units:'mm',tab:1});

    const onChange=(formData)=>{
        setTableInfo(formData);
    };
    const _onCancel=()=>{
        onCancel();
    };
    const _onOK=()=>{
        onOK(tableInfo);
    };
    const alignOptions=()=>{
        return jwordAlignmentOptions.map((opt)=>{return {label:t('Editor.align.'+opt),value:opt}});
    }
    const unitOptions=()=>{
        return jwordUnitOptions.map((opt)=>{return {label:t('Editor.unit.'+opt),value:opt}});
    }
    const valignOptions=()=>{
        return jwordValignOptions.map((opt)=>{return {label:t('Editor.valign.'+opt),value:opt}});        
    }
    const rowHeightOptions=()=>{
        return jwordRowHeightOptions.map((opt)=>{return {label:t('Editor.rowHeight.'+opt),value:opt}});
    }
    useEffect(()=>{
        console.log("tableProps:"+JSON.stringify(tableProps));
        setTableInfo({...tableProps});
    },[]);
    useEffect(()=>{
        console.log("tableProps:"+JSON.stringify(tableProps));
        setTableInfo({...tableProps});
    },[tableProps]);
    return(
        <>
        <CommonDialog header={t('Editor.Table_format')} visible={visible} onOK={_onOK} onCancel={_onCancel}>
            <div className="p-2" style={{width:'400px',minHeight:'400px'}}>
            <TabView activeIndex={tableInfo.tab}>
                <TabPanel header={t('Editor.Table')}>
                    <Form id="formatTable" formData={tableInfo} columns="1" onChange={onChange}
                        fields={[
                            {id:"align",ftype:"dropdown",field:"align",label:t('Editor.Alignment'),options:alignOptions()}
                        ]}>
                    </Form>	
                    <Form id="formatTable2" formData={tableInfo} columns="2" onChange={onChange}
                        fields={[
                            {id:"leftIndent",ftype:"number",field:"leftIndent",label:t('Editor.Left_Indent')+" ("+tableProps.units+")"},
                            {id:"cellSpacing",ftype:"number",field:"cellSpacing",label:t('Editor.Cell_Spacing')},
                            {id:"tableWidth",ftype:"number",field:"tableWidth",label:t('Editor.Table_Width')},
                            {id:"widthUnit",ftype:"dropdown",field:"widthUnit",label:t('Editor.Unit'),options:unitOptions()}
                        ]}>
                    </Form>	
                    <Panel header={t('Editor.Cell_Margins')}>
                        <Form id="formatTableCellMrg" formData={tableInfo} columns="2" onChange={onChange}
                            fields={[
                                {id:"leftMargin",ftype:"number",field:"leftMargin",label:t('Editor.Left')},
                                {id:"rightMargin",ftype:"number",field:"rightMargin",label:t('Editor.Right')},
                                {id:"topMargin",ftype:"number",field:"topMargin",label:t('Editor.Top')},
                                {id:"bottomMargin",ftype:"number",field:"bottomMargin",label:t('Editor.Bottom')}
                            ]}>
                        </Form>	
                    </Panel>
                </TabPanel>
                <TabPanel header={t('Editor.Cell')}>
                    <Form id="formatTableCell" formData={tableInfo} columns="1" onChange={onChange}
                        fields={[
                            {id:"vAlign",ftype:"dropdown",field:"vAlign",label:t('Editor.Vertical_Alignment'),options:valignOptions()},
                            {id:"inheritMargins",ftype:"checkbox",field:"inheritMargins",label:t('Editor.Inherit_margins_from_table')}
                        ]}>
                    </Form>	
                    <Panel header={t('Editor.Cell Margins')}>
                        <Form id="formatTableCellMrg" formData={tableInfo} columns="2" onChange={onChange}
                            fields={[
                                {id:"cellLeftMargin",ftype:"number",field:"cellLeftMargin",label:t('Editor.Left'),disabled:tableInfo.inheritMargins},
                                {id:"cellRightMargin",ftype:"number",field:"cellRightMargin",label:t('Editor.Right'),disabled:tableInfo.inheritMargins},
                                {id:"cellTopMargin",ftype:"number",field:"cellTopMargin",label:t('Editor.Top'),disabled:tableInfo.inheritMargins},
                                {id:"cellBottomMargin",ftype:"number",field:"cellBottomMargin",label:t('Editor.Bottom'),disabled:tableInfo.inheritMargins}
                            ]}>
                        </Form>	
                    </Panel>                    
                </TabPanel>
                <TabPanel header={t('Editor.Row')}>
                    <Form id="formatTableRow" formData={tableInfo} columns="2" onChange={onChange}
                        fields={[
                            {id:"rowHeightMode",ftype:"dropdown",field:"rowHeightMode",label:t('Editor.Row_Height_Mode'),options:rowHeightOptions()},
                            {id:"rowHeight",ftype:"number",field:"rowHeight",label:t('Editor.Row_Height')}
                        ]}>
                    </Form>	
                </TabPanel>
                <TabPanel header={t('Editor.Column')}>
                    <Form id="formatTableCol" formData={tableInfo} columns="2" onChange={onChange}
                        fields={[
                            {id:"columnWidth",ftype:"number",field:"columnWidth",label:t('Editor.Column_Width')},
                            {id:"columnWidthUnit",ftype:"dropdown",field:"columnWidthUnit",label:t('Editor.Unit'),options:unitOptions()}
                        ]}>
                    </Form>	
                </TabPanel>
            </TabView>
            </div>
        </CommonDialog>
        </>
    );
}